<template>
  <div class="container my-20">
    <div class="lg:flex-nowrap flex flex-wrap items-center gap-8 lg:gap-0">
      <div class="lg:w-1/2 lg:p-16 lg:mb-0 w-full" :class="{ 'order-1': invert }">
        <h2 v-if="heading" class="fluid-3xl leading-tightest pr-8" v-html="heading"></h2>
        <div
          v-if="body"
          class="fluid-base leading-relaxed font-light text-copy mt-8"
          :class="{ 'image-legend': useImageLegend }"
          v-html="body"
        ></div>
        <LinkField v-if="cta[0] && cta[0].text" v-bind="cta[0]" class="btn-pill-outline-black mt-8" />
      </div>
      <div class="lg:w-1/2 w-full" :class="{ 'order-0': invert }">
        <CraftAsset
          v-if="image[0]"
          :alt="alt"
          :asset="image[0]"
          :ratio="1 / aspectRatio"
          sizes="90vw sm:90vw md:50vw lg:50vw xl:50vw 2xl:50vw"
          crop="fill"
          :autoplay="true"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CraftAsset from '~/components/common/CraftAsset';
import LinkField from '~/components/common/LinkField';

export default defineNuxtComponent({
  name: 'ImageText',
  components: { LinkField, CraftAsset },
  props: {
    image: {
      type: Array,
      default: () => [],
    },
    alt: {
      type: String,
      default: null,
    },
    invert: {
      type: Boolean,
      default: false,
    },
    heading: {
      type: String,
      default: null,
    },
    body: {
      type: String,
      default: null,
    },
    cta: {
      type: Array,
      default: () => [],
    },
    useImageLegend: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    aspectRatio() {
      return (this.image.length && this.image[0].height / this.image[0].width) || 1;
    },
  },
});
</script>

<style scoped>
.image-legend :deep(ol) {
  counter-reset: legend-counter;
  list-style: none;
  padding-left: 0;
  margin-top: 0;
  margin-bottom: 0;
}

.image-legend :deep(ol li) {
  counter-increment: legend-counter;
  position: relative;
  padding-bottom: 0.5rem;
}

.image-legend :deep(ol li::before) {
  content: counter(legend-counter);
  position: absolute;
  left: -2rem;
  top: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.5rem;
  height: 1.5rem;
  background-color: var(--color-br-green);
  color: white;
  font-weight: 700;
  font-size: 13px;
  border-radius: 50%;
}

@media (min-width: var(--breakpoint-md)) {
  .image-legend :deep(ol li::before) {
    top: 0.2em;
  }
}
</style>
